



import { Component, Vue, Prop } from "vue-property-decorator";
import { vacation } from "../../api/vacation";
import * as moment from "moment";
@Component({ name: "DownloadVacation" })

export default class DownloadVacation extends Vue {
  public test1: any = {};
  public object: any ={};
  public id: any= '';
  public async Vacation1() {
    console.log(this.object.id)
    console.log("xxxxxxxxxxy")
if(this.object.id != undefined){
//console.log("xxxxxxxxxxy")
    let response = await vacation.Vacation1(this.$store.getters.getToken, this.object.id ,this.$store.getters.getHost);
    let jsonObj = await response.json();
    this.test1 = jsonObj;
    }else{
       this.id=-1
      let response = await vacation.Vacation1(this.$store.getters.getToken, this.id ,this.$store.getters.getHost);
    let jsonObj = await response.json();
    this.test1 = jsonObj;
    }
    // console.log('lalalalala =====> ' + jsonObj);
      // .then(response => {
      //   response.json().then(resp => {
      //    this.test1 = JSON.parse(JSON.stringify(resp));
      //     console.log(this.test1)
      //     console.log("this.test1")
         
      //   });
      // });

    // .then(r => {
    //   if (r.status == 400) {
    //     this.$message.error(r.error);
    //   } else {
    //     this.$router.replace({
    //       name: "load"
    //     });
    //   }
    // });
  }

  public async mounted() {
    
    console.log(this.test1);
    
    console.log('AFTER VACATION1');
    console.log('this.test1');
    console.log(this.test1);
    //     let tem6 = this.test1.findOne({});
    
    
    console.log(this.test1)
    console.log("lydia")

    this.id = this.$store.getters.getCurrentId;
    let token = this.$store.getters.getToken;
    this.object = this.$store.getters.getCurrentObject;
    await this.Vacation1();
    console.log("testofdownloadVacatiexfront");
    console.log(this.id);
    console.log(token);
    console.log(this.object);
    console.log(this.object.id)
    console.log("testofdownloadVacatio");
    //setCurrentId -1 gia epistrofi
    this.$store.dispatch("setCurrentId", -1);
    //AddNewVacation arxiki othoni ekei pou thelw na giriso
    
    
    

   // this.$store.dispatch("updateCurrentComponent","ViewVacationSubmitted");
    this.$router.replace({
      name: "load"
    });
    if(this.object.id== undefined){
      
    this.$store.dispatch("updateCurrentComponent", "AddNewVacation");
    let response = await vacation.downloadVacation(token, this.id, this.$store.getters.getHost);
    response.blob().then((blob: any) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      
      a.download = this.test1.lastnamegr+'_'+this.test1.total_days_req+'_'+moment(this.test1.leave_on).format("DD/MM/YYYY")+".xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove(); //afterwards we remove the element again
    });

}else{


if(this.object.decisionofvacation==2){
  
this.$store.dispatch("updateCurrentComponent", "ViewVacationSubmitted");
let response = await vacation.downloadVacation(token, this.object.id, this.$store.getters.getHost);
    response.blob().then((blob: any) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      
      a.download = this.test1.lastnamegr+'_'+this.test1.total_days_req+'_'+moment(this.test1.leave_on).format("DD/MM/YYYY")+".xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove(); //afterwards we remove the element again
    });
}else{

this.$store.dispatch("updateCurrentComponent", "Decisionofvacation");
let response = await vacation.downloadVacation(token, this.object.id, this.$store.getters.getHost);
    response.blob().then((blob: any) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      
      a.download = this.test1.lastnamegr+'_'+this.test1.total_days_req+'_'+moment(this.test1.leave_on).format("DD/MM/YYYY")+".xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove(); //afterwards we remove the element again
    });



}



}

  }
}
